<template>
    <div class="body">
        <div class="content">
            <!-- <div class="back" @click="$router.go(-1)">
                <img src="../../assets/img/i19.png" />
                返回
            </div> -->
            <div class="one" v-show="flag == 1">
                <img class="o_icon" src="../../assets/img/i10.png" />
                <div class="o_title">您好，欢迎使用{{ type == 1 ? '课堂应用' : '讲座会议' }}</div>
                <div class="o_jl" @click="$router.push({ path: '/simultaneousInterpretationRecord' })">
                    历史记录
                    <img src="../../assets/img/i36.png" />
                </div>
                <div class="o_btn" @click="start">
                    <img src="../../assets/img/i32.png" />
                    点击开始
                </div>
            </div>
            <div class="two" v-show="flag == 2">
                <div class="t_content" ref="scrollDiv">
                    <div class="tc_item" v-for="(item, index) in formatContent(content)" :key="index"
                        :class="index == formatContent(content).length - 1 ? 'itext' : ''" v-html="item.text"></div>
                </div>
                <div class="t_bottom">
                    <div class="tb_btn" @click="btn_stop" v-if="isCanStop">
                        <img src="../../assets/img/i34.png" />
                        暂停录音
                    </div>
                    <div class="tb_btn" @click="btn_continue" v-else>
                        <img src="../../assets/img/i33.png" />
                        继续录音
                    </div>
                    <div class="tb_btn1" @click="endPop = true">
                        <img src="../../assets/img/i41.png" />
                        点击结束
                    </div>
                    <div class="tb_btn2">{{ formattedTime }}</div>
                </div>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="endPop" width="30%">
            <span>是否确定结束当前录制?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="endPop = false">取 消</el-button>
                <el-button type="primary" @click="end">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { signCallback } from '@/assets/tengxunyun/examples/asrauthentication.js';
import '@/assets/tengxunyun/examples/config.js';
import '@/assets/tengxunyun/dist/speechrecognizer.js';

import {
    transRecordSave,
    saveNew
} from '@/apis/index'
export default {
    data() {
        return {
            flag: 1,
            type: this.$route.query.type,
            recorder: '',
            speechRecognizer: '',
            isCanSendData: false,
            isCanStop: false,
            scrollTop: 0,
            scrollIndex: '',
            content: '',
            scrollTime: '',
            list: [],
            resultText: '',
            id: '',
            operationType: null, //1是暂停2是结束
            tips: '',
            timer: null, // 定时器
            elapsedTime: 0, // 已经过的时间（毫秒）
            isRunning: false, // 计时器是否正在运行
            endPop: false,
        }
    },
    computed: {
        formattedTime() {
            const seconds = Math.floor(this.elapsedTime / 1000);
            const minutes = Math.floor(seconds / 60);
            const displaySeconds = seconds % 60;
            return `${this.padZero(minutes)}:${this.padZero(displaySeconds)}`;
        }
    },
    mounted() {
        // console.log(JSON.parse(localStorage.getItem('userInfo')),'userid');

        // if(!localStorage.getItem('token')){
        //     this.$router.replace('/login')   
        // }
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    destroyed() {
        localStorage.setItem('simultaneousInterpretation', this.content)
        this.stopTxy();
        clearInterval(this.timer); // 组件销毁时清除定时器
    },
    methods: {
        handleBeforeUnload(event) {
            // 设置提示信息
            const message = '当前正在录制中，离开后可能会导致本次数据丢失，确定要离开吗？';
            event.returnValue = message; // 现代浏览器会显示默认提示
            return message; // 某些浏览器会使用这个返回值
        },
        // 滚动到底部
        handleScrollBottom() {
            this.$nextTick(() => {
                let scrollElem = this.$refs.scrollDiv;
                scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
            });
        },
        start() {
            this.throttle(() => {
                this.flag = 2
                setTimeout(() => {
                    this.startTimer()
                }, 1000)
                this.startTxy();
            }, 2000)
        },
        padZero(num) {
            return num < 10 ? '0' + num : num;
        },
        startTimer() {
            if (this.isRunning) return;
            this.isRunning = true;
            this.timer = setInterval(() => {
                this.elapsedTime += 1000; // 每秒增加1000毫秒
            }, 1000);
        },
        pauseTimer() {
            if (!this.isRunning) return;
            clearInterval(this.timer);
            this.isRunning = false;
        },
        resumeTimer() {
            if (this.isRunning) return;
            this.startTimer();
        },
        resetTimer() {
            clearInterval(this.timer);
            this.elapsedTime = 0;
            this.isRunning = false;
        },
        getInfo() {
            // var index = 0
            // setInterval(()=>{
            // 	this.content += `${index}喂喂喂，本节课主要本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事讲述老人与海的故事本节课主要本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事讲述老人与海的故事本节课主要本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事讲述老人与海的故事本节课主要本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事本节课主要讲述老人与海的故事讲述老人与海的故事`
            // 	index++
            // 	this.isPositioning();
            // },800)
            setTimeout(() => {
                this.startTimer()
            }, 1000)
            this.startTxy();
        },
        // 结束录制并提交后台
        end() {
            this.throttle(() => {
                this.recorder.stop();
                if (this.isCanStop) {
                    this.speechRecognizer.stop();
                    this.isCanStop = false;
                    this.isCanSendData = false;
                    this.speechRecognizer = '';
                }
                var info = JSON.parse(localStorage.getItem('userInfo'))
                saveNew({
                    type: this.type,
                    transText: this.content,
                    userId: info.userId,
                    totalTime: this.elapsedTime / 1000
                }).then(res => {
                    console.log(res, 'transRecordSave');
                    this.endPop = false
                    this.flag = 1
                    this.content = ''
                    localStorage.removeItem('simultaneousInterpretation')
                    this.$router.push({ path: '/simultaneousInterpretationRecord' })
                    // , query: { id: item.id,type:item.type }
                })
            }, 2000)

        },
        // 开始、暂停录制
        btn_continue() {
            this.throttle(() => {
                console.log('btn_continue')
                this.operationType = 1;
                this.resumeTimer()
                this.startTxy();
            }, 2000)
        },
        btn_stop() {
            this.throttle(() => {
                console.log('btn_stop')
                this.operationType = 2;
                this.pauseTimer()
                this.stopTxy();
            }, 2000)
        },
        btn() {
            this.throttle(() => {
                console.log('btn')
                this.operationType = 1;
                if (!this.isCanStop) {
                    this.resumeTimer()
                    this.startTxy();
                    console.log('btn')

                } else {
                    this.pauseTimer()
                    this.stopTxy();
                    console.log('btn1')
                }
            }, 2000)

        },
        // 暂停
        stopTxy() {
            localStorage.setItem('simultaneousInterpretation', this.content)
            this.recorder.stop();
            if (this.isCanStop) {
                this.speechRecognizer.stop();
                this.isCanStop = false;
                this.isCanSendData = false;
                this.speechRecognizer = '';
            }
        },
        // 开始
        startTxy() {
            if (this.recorder) {
                this.recorder.stop();
                if (this.isCanStop) {
                    this.speechRecognizer.stop();
                    this.isCanStop = false;
                    this.isCanSendData = false;
                    this.speechRecognizer = '';
                }
            }
            const params = {
                signCallback: signCallback, // 鉴权函数 用户提供鉴权函数，不传则为null
                // 用户参数
                secretid: config.secretId,
                appid: config.appId,
                // 实时识别接口参数
                engine_model_type: '16k_zh', // 引 擎_en
                // voice_format: 1,
                // 以下为非必填参数，可跟据业务自行修改
                // hotword_id: '08003a00000000000000000000000000',
                needvad: 1,
                // filter_dirty: 1, //脏词
                // filter_modal: 1, //语气词
                filter_punc: 0, //是否过滤句末的句号
                // convert_num_mode: 1,
                // word_info: 2,
                // vad_silence_time: 2000
            };
            // 获取录音数据
            this.recorder = new WebRecorder();
            this.recorder.OnReceivedData = (res) => {
                // console.log(res) // res 为采集到浏览器数据
                if (this.isCanSendData) {
                    // 发送数据
                    this.speechRecognizer.write(res);
                }
            };
            // 录音失败时
            this.recorder.OnError = (err) => {
                console.log(err);
                this.recorder.stop();
            };
            this.recorder.start()

            if (!this.speechRecognizer) {
                this.speechRecognizer = new SpeechRecognizer(params);
            }

            // 开始识别
            this.speechRecognizer.OnRecognitionStart = (res) => {
                console.log('开始识别', res);
                this.isCanSendData = true;
                this.isCanStop = true;
                if (localStorage.getItem('simultaneousInterpretation')) {
                    this.resultText += localStorage.getItem('simultaneousInterpretation')
                    this.content = this.resultText
                }

            };
            // 一句话开始
            this.speechRecognizer.OnSentenceBegin = (res) => {
                console.log('一句话开始', res);
            };
            // 识别变化时
            this.speechRecognizer.OnRecognitionResultChange = (res) => {
                console.log('识别变化时', res);
                this.content = `${this.resultText}${res.result.voice_text_str}`
                this.handleScrollBottom();

            };
            // 一句话结束
            this.speechRecognizer.OnSentenceEnd = (res) => {
                console.log('一句话结束', res);
                this.resultText += res.result.voice_text_str;
                this.content = this.resultText
                this.handleScrollBottom();
            };
            // 识别结束
            this.speechRecognizer.OnRecognitionComplete = (res) => {
                console.log('识别结束', res);
                localStorage.setItem('simultaneousInterpretation', this.content)
                this.pauseTimer()
                //1是暂停2是结束
                console.log(this.operationType, 'operationType');
                // 非结束标识并且code正常的情况下默认为用户主动暂停，反之code不等于0则默认为出现异常。这两种情况都会弹窗，暂停方法不弹窗。
                if (this.operationType != 2 && res.code == 0) {
                    this.tips = '实时录音已暂停,是否继续录音？';
                    // this.$refs.stopPop.open();
                } else if (res.code != 0) {
                    this.tips = '检测到网络原因导致实时录音已暂停，请确认网络状态良好后再继续录音！';
                    // this.$refs.stopPop.open();
                    // console.log(this.$refs.stopPop.maskShow);
                }
            };
            // 识别错误
            this.speechRecognizer.OnError = (res) => {
                console.log('识别失败', res);
                localStorage.setItem('simultaneousInterpretation', this.content)
                this.pauseTimer()
                // 这里是有res.message的情况下，貌似还会出现没有res.message的情况，所以做了双重处理
                if (res.code && res.message) {
                    this.stopTxy();
                } else if (res.code && !res.message) {
                    this.stopTxy();
                    // this.toast('录音失败，请检查网络是否正常后重试！');
                }
                setTimeout(() => {
                    this.btn_continue();
                }, 3000);
            };
            // 建立连接
            this.speechRecognizer.start();
        },
        formatContent(text) {
            // 使用正则表达式在句号后 添加换行符
            // return text.replace(/(。)(\s*)/g, '。<br/>');
            // var newText = text.replace(/(。)(\s*)/g, '。<br/>');
            // 分割文本为数组
            var sentences = text.split('。');
            // 转换为 [{text: '', id: ''}] 格式
            var result = sentences
                .map((sentence, index) => {
                    // 去除句子前后的空白字符
                    sentence = sentence.trim();
                    return {
                        text: sentence, // 句子内容
                        id: new Date().getTime() // 生成唯一 id（从 1 开始）
                    };
                })
                .filter((item) => item.text !== ''); // 过滤掉空句子
            // console.log(result, 'result');

            return result;
        },
    }
}
</script>

<style lang="scss" scoped>
.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;



    .content {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;
        box-sizing: border-box;
        background-color: #fff;
        margin: 20px 0;
        padding: 20px 0;

        .back {
            width: 100%;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            color: #000000;
            margin-bottom: 10px;
            margin-top: 10px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;

            }
        }

        .one {
            width: 100%;
            height: 100%;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .o_icon {
                width: 86px;
                height: 108px;
            }

            .o_title {
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                margin-top: 20px;
            }

            .o_jl {
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                font-size: 16px;
                color: #2992FF;
                margin-bottom: 260px;
                margin-top: 20px;
                cursor: pointer;


                img {
                    width: 7px;
                    height: 7px;
                }
            }

            .o_btn {
                width: 140px;
                height: 140px;
                background: #2992FF;
                border-radius: 70px 70px 70px 70px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                cursor: pointer;

                img {
                    width: 48px;
                    height: 48px;
                    margin-bottom: 15px;
                }
            }
        }

        .two {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .t_content::-webkit-scrollbar {
                display: none;
            }

            .t_content {
                width: 100%;
                height: 0;
                flex: 1;
                overflow-y: scroll;
                box-sizing: border-box;
                padding: 40px 100px;
                font-weight: 400;
                font-size: 18px;
                color: #333333;
                line-height: 32px;

                .tc_item {
                    width: 100%;
                    background: #F3F5FA;
                    border-radius: 12px;
                    box-sizing: border-box;
                    padding: 20px;
                    margin-top: 30px;
                    letter-spacing: 1px;
                    line-height: 45px;
                    font-weight: bold;
                }

                .itext {
                    background: linear-gradient(62deg, #194DFC 0%, #448DF8 100%) !important;
                    color: #fff !important;
                }
            }

            .t_bottom {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;
                position: relative;

                .tb_btn2 {
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    margin-left: 30px;
                }

                .tb_btn1 {
                    display: flex;
                    // flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 130px;
                    height: 36px;
                    background: #EC3B3B;
                    border-radius: 8px 8px 8px 8px;
                    font-weight: 800;
                    font-size: 16px;
                    color: #FFFFFF;
                    cursor: pointer;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 10px;
                    }
                }

                .tb_btn {
                    width: 140px;
                    height: 36px;
                    display: flex;
                    // flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-weight: 500;
                    font-size: 16px;
                    color: #333333;
                    margin-right: 30px;
                    cursor: pointer;
                    border: 1px solid #399AFF;
                    border-radius: 8px 8px 8px 8px;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
</style>